import { NgModule } from '@angular/core';
import { CommonModule, APP_BASE_HREF } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from './material/material.module';

import { RouterModule } from '@angular/router';
import { GraphicModule } from '../graphic/graphic.module';
import { CustomMatFormFieldsModule } from '../core/custom-mat-form-fields/custom-mat-form-fields.module';

@NgModule({
  declarations: [],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
  imports: [],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MaterialModule,
    CustomMatFormFieldsModule,
    RouterModule,
    GraphicModule
  ]
})
export class SharedModule {}
